// @ts-nocheck
/* eslint-disable */
/**
 * @class Jedna polozka vysledku hledani v pravem sloupci - reklama
 */
export default class Adv {
	constructor(owner, advData) {
		this._owner = owner;
		this._data = advData;
		this._dom = {
			container: Mapy.Util.node("li")
		};

		this._build();
	}

	getContainer() {
		return this._dom.container;
	}

	handleEvent(e) {
		// prvni bude vzdycky pointerdown, potom az click
		if (e.type == "pointerdown") {
			// vlastni statistiky, analytika
			Mapy.getComponent("logger").log("notfound-sklik-click");
		}
	}

	_build() {
		var link = Mapy.Util.node("a", { className: "li-inner", href: this._data.href });
		var imgDiv = Mapy.Util.node("div", { className: "ui-poilistimage" });
		var img = new Image();
		img.crossOrigin = "anonymous";
		img.src = this._data.img;
		imgDiv.appendChild(img);
		link.appendChild(imgDiv);
		var content = Mapy.Util.node("div", { className: "content" });
		var title = Mapy.Util.node("h3", { textContent: this._data.title });
		var type = Mapy.Util.node("p", { className: "type-name", textContent: this._data.secondRow });
		content.appendChild(title);
		content.appendChild(type);

		var restContent = Mapy.Util.node("div");
		var restContentInner = Mapy.Util.node("div");
		restContent.appendChild(restContentInner);
		var address = Mapy.Util.node("div", { className: "address" });

		if (this._data.thirdRow) {
			var thirdRow = Mapy.Util.node("p", { textContent: this._data.thirdRow });
			address.appendChild(thirdRow);
		}

		restContentInner.appendChild(address);
		content.appendChild(restContent);

		link.appendChild(content);
		link.addEventListener("pointerdown", this);

		this._dom.container.appendChild(link);

		if (this._data.exImpUrl && this._data.exImpUrl.length) {
			this._data.exImpUrl.forEach(i => {
				var extImp = Mapy.Util.node("img", { src: i, style: "width: 0px; height: 0px; position: absolute;" });
				this._dom.container.appendChild(extImp);
			})
		}
	}
};
